import { SOURCE_DATA_TYPES } from './constants'

export const SOURCE_DATA_GETTER_TYPES = Object.keys(SOURCE_DATA_TYPES).reduce(
  (acc, value) => ({ ...acc, [value]: value }),
  {},
)

export const ROOT_GETTER_TYPES = {
  SOURCE_DATA: 'SOURCE_DATA',
  FORM_DATA: 'FORM_DATA',
  FORM_ERRORS: 'FORM_ERRORS',
  FORM_PENDING: 'FORM_PENDING',
  FORM_SUCCESSFUL_SUBMITTED: 'FORM_SUCCESSFUL_SUBMITTED',
  SKIP_STEPS: 'SKIP_STEPS',
}

export const GETTER_TYPES = {
  // PAYMENT_ADDRESS: 'PAYMENT_ADDRESS',
  PAYMENT_ADDRESS_COUNTRY_ID: 'PAYMENT_ADDRESS_COUNTRY_ID',
  DELIVERY_ADDRESSES: 'DELIVERY_ADDRESSES',
  SW_BRANDS: 'SW_BRANDS',
  USER_NAME: 'USER_NAME',
  USER_GROUP: 'USER_GROUP',
  PARENT_CUSTOMER_NUMBER: 'PARENT_CUSTOMER_NUMBER',
  // SUB_USER_TYPE: 'SUB_USER_TYPE',
  CUSTOMER_NUMBER: 'CUSTOMER_NUMBER',
  TRANSFORMED_PAYMENT_ADDRESS: 'TRANSFORMED_PAYMENT_ADDRESS',
  TRANSFORMED_DELIVERY_ADDRESSES: 'TRANSFORMED_DELIVERY_ADDRESSES',
  CALCULATION_DESIRE: 'CALCULATION_DESIRE',
  TICKET_TYPE: 'TICKET_TYPE',
  CTDI_DESCRIPTIONS: 'CTDI_DESCRIPTIONS',
  USER_FORM_DATA: 'USER_FORM_DATA',
  BIKE_DATA: 'BIKE_DATA',
  COMPONENT_SELECTIONS: 'COMPONENT_SELECTIONS',
  CHECKBOX_SELECTIONS: 'CHECKBOX_SELECTIONS',
}

export default {
  ...SOURCE_DATA_GETTER_TYPES,
  ...ROOT_GETTER_TYPES,
  ...GETTER_TYPES,
}
